import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Hide2Icon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M1600 1152q93 0 174 35t143 96 96 142 35 175q0 93-35 174t-96 143-142 96-175 35q-93 0-174-35t-143-96-96-142-35-175q0-93 35-174t96-143 142-96 175-35zm-320 448q0 66 25 124t68 102 102 69 125 25q47 0 92-13t84-40l-443-443q-26 39-39 84t-14 92zm587 176q26-39 39-84t14-92q0-66-25-124t-69-101-102-69-124-26q-47 0-92 13t-84 40l443 443zM1 1026l-1 3v-5l1 2zm1910 15q-18-104-63-193t-111-162-148-129-175-94-192-59-198-20q-109 0-217 24t-208 70-186 113-149 152-100 188-36 221H0q0-136 40-255t113-218 169-178 211-133 239-83 252-29q125 0 249 28t238 82 210 131 170 176 113 217 44 253q-61-59-137-102zm-887-145q-53 0-99 20t-82 55-55 81-20 100q0 48 17 91t46 78 70 56 89 29q-20 64-26 125-70-11-129-45t-102-84-68-115-25-135q0-79 30-149t82-122 122-83 150-30q57 0 111 16t100 47 82 74 60 95q-62 23-115 57-15-36-39-66t-55-51-68-32-76-12z" />
    </svg>
  ),
  displayName: 'Hide2Icon',
});

export default Hide2Icon;
